import { FC, ReactNode } from 'react';
import classNames from 'classnames';

type Props = {
  children?: ReactNode;
  className?: string;
};

const H3: FC<Props> = ({ children, className }) => (
  <h3
    className={classNames(
      'font-lexend text-[24px] leading-[32px] font-medium tablet:text-h3',
      className,
    )}
  >
    {children}
  </h3>
);

export default H3;
